import gql from 'graphql-tag';

export const ArchivedPageBannerContainerQuery = gql`
	query ArchivedPageBannerContainerQuery($contentId: ID) {
		content(id: $contentId, status: ["archived", "current"]) {
			nodes {
				id
				status
			}
		}
	}
`;
